import React, {FC} from 'react';
import Toggle from 'react-toggle';

import {TimelineCommentators} from 'utils/types';

import './styles.scss';
import 'react-toggle/style.css';

interface Props {
  commentary?: TimelineCommentators;
  commentaryEnabled: boolean;
  setCommentaryEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

const TimelineCommentary: FC<Props> = ({
  commentary,
  commentaryEnabled,
  setCommentaryEnabled,
}: Props) => {
  return commentary && (commentary.reporters.length || commentary.commentators.length) ? (
    <div className="TimelineCommentary">
      {!!commentary.reporters.length && (
        <>
          <h5 className="TimelineCommentary__label">ΠΕΡΙΓΡΑΦΗ</h5>
          <p className="TimelineCommentary__commentators">
            {commentary.reporters.map(rep => (
              <span key={rep}>{rep} </span>
            ))}
          </p>
        </>
      )}
      {!!commentary.commentators.length && (
        <>
          <h5 className="TimelineCommentary__label">ΣΧΟΛΙΑΣΜΟΣ</h5>
          <p className="TimelineCommentary__commentators">
            {commentary.commentators.map(comm => (
              <span key={comm}>{comm}</span>
            ))}
          </p>
        </>
      )}
      <div className="TimelineCommentary__toggle">
        <Toggle
          checked={commentaryEnabled}
          onChange={() => setCommentaryEnabled(!commentaryEnabled)}
          icons={{checked: <span>ON</span>, unchecked: <span>OFF</span>}}
        />
      </div>
    </div>
  ) : null;
};

export default TimelineCommentary;
